<template>
    <client-page class="wrap--sub">
        <sub-visual :visual="title" :class="className" />
        <div class="contents">
            <div class="container">
                <search v-model="searchValue" @search="search()" @clickArea="toggleShowArea" />
                <filter-areas v-model="filter" :areas="areas" :areas_manual="areas_manual" :showArea="showArea" @close="toggleShowArea" />
                <list-item v-for="expert in experts" :key="expert._id" :expert="expert" />
                <pagination-component v-model="page" :count="pageCount" />
            </div>
        </div>
    </client-page>
</template>

<script>
import api from "@/api";
import Search from "@/components/client/experts/search.vue";
import ListItem from "@/components/client/experts/list-item.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import FilterAreas from "@/components/client/experts/filter-areas.vue";
import PaginationComponent from "@/components/client/control/pagination-component.vue";
import { USER_TYPES } from "@/assets/data/CONSTANTS";

export default {
    components: {
        Search,
        ListItem,
        SubVisual,
        ClientPage,
        FilterAreas,
        PaginationComponent,
    },
    props: ["userType"],
    computed: {
        type() {
            return USER_TYPES[this.userType?.toUpperCase()];
        },
        title() {
            if (this.type == USER_TYPES.ORGANIZATION) return "전문기업 검색";
            if (this.type == USER_TYPES.INDIVIDUAL) return "전문가 검색";
        },
        className() {
            if (this.type == USER_TYPES.ORGANIZATION) return "sv3";
            if (this.type == USER_TYPES.INDIVIDUAL) return "sv4";
        },
        structuredFilter() {
            const {
                type,
                searchValue = null,
                filter: { _areas = [], areas_manual: manual = [] },
            } = this;

            const areas_manual = JSON.stringify(
                manual.reduce((areas, { _parent, name }) => {
                    let parentArea = areas.find((area) => area._parent == _parent);
                    if (!parentArea) {
                        areas.push({ _parent, names: [] });
                        parentArea = areas[areas.length - 1];
                    }
                    parentArea.names = [...parentArea.names, name];
                    return areas;
                }, [])
            );

            return {
                type,
                searchValue,
                _areas,
                areas_manual,
            };
        },
    },
    data() {
        return {
            searchValue: null,
            filter: {
                _areas: [],
                areas_manual: [],
            },

            areas: [],
            areas_manual: [],

            page: 1,
            pageCount: 0,
            totalCount: 0,
            limit: 10,

            experts: [],

            showArea: false,
        };
    },
    methods: {
        async init() {
            try {
                const { type } = this;
                const { areas } = await api.v1.areas.gets({ params: { type } });
                this.areas = areas;

                const { areas: areasManual } = await api.v1.areas.gets({ params: { isManual: true, type } });
                this.areas_manual = areasManual;

                let { _areas = [], areas_manual: manual = "[]", searchValue = null, page = 1 } = this.$route.query;
                page = +page;

                if (typeof _areas == "string") _areas = [_areas];
                let areas_manual = JSON.parse(manual).flatMap(({ _parent, names }) => names.map((name) => ({ _parent, name })));

                this.searchValue = searchValue;
                this.filter = {
                    _areas,
                    areas_manual,
                };
                this.page = page;

                if (_areas.length || areas_manual.length) this.showArea = true;

                this.$nextTick(() => this.search(false));
            } catch (error) {
                this.$handleError(error);
            }
        },
        async search(routable = true) {
            this.setRoute(routable);

            try {
                const {
                    summary: { totalCount },
                    experts,
                } = await api.v1.experts.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: { ...this.structuredFilter },
                });
                this.totalCount = totalCount;
                this.pageCount = Math.ceil(totalCount / this.limit);
                this.experts = experts;
            } catch (error) {
                this.$handleError(error);
            }
        },
        setRoute(routable) {
            if (routable) {
                this.$router.push({
                    query: Object.assign({}, { ...this.structuredFilter }, { page: this.page }),
                });
            }
        },
        toggleShowArea() {
            this.showArea = !this.showArea;
        },
        goItem({ _id }) {
            this.$router.push(`/experts/${_id}`);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        userType() {
            this.init(false);
        },
    },
};
</script>

<style lang="scss"></style>
